import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'

window.axios = axios;

Vue.config.productionTip = false

Vue.use(VueAxios, axios);

new Vue({
  //vuetify,
  render: h => h(App)
}).$mount('#asre_calendar')
